import { BottomSheet, IconReportLine, IconSquare2StackedLine, MenuSheetItem } from "@hamlak/ui";
import { t } from "@/i18n/ko";

type Props = { open: boolean; onCopy: () => void; /** 캐릭터 메시지일 때만: 신고(1.21). */ onReport?: (() => void) | undefined; onClose: () => void };

/** 1.9 메시지 길게 누르기 → 액션 시트: "복사" (+ 캐릭터 메시지면 "신고"). */
export function CopySheet({ open, onCopy, onReport, onClose }: Props) {
  return (
    <BottomSheet open={open} onClose={onClose} data-testid="copy-sheet">
      <div className="chat__menuList">
        <MenuSheetItem icon={<IconSquare2StackedLine />} label={t("chat.copy")} onClick={onCopy} />
        {onReport && <MenuSheetItem icon={<IconReportLine />} label={t("chat.report")} tone="critical" onClick={onReport} />}
      </div>
    </BottomSheet>
  );
}
